import dayjs, { isDayjs } from "dayjs"
import plugInDuration from "dayjs/plugin/duration"
import plugInUTC from "dayjs/plugin/utc"
import isBetween from "dayjs/plugin/isBetween"
import isSameOrAfter from "dayjs/plugin/isSameOrAfter"
import updateLocale from "dayjs/plugin/updateLocale"
import customParseFormat from "dayjs/plugin/customParseFormat"
import isSameOrBefore from "dayjs/plugin/isSameOrBefore"

dayjs.extend(plugInUTC)
dayjs.extend(plugInDuration)
dayjs.extend(isBetween)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(updateLocale)
dayjs.extend(customParseFormat)
dayjs.updateLocale("en", { weekStart: 1 })

export { isDayjs }
export default dayjs
